import type { StatusPillTone } from '../StatusPill';

export function getClaimStatusBadge(
  claimStatus: string
): { label: string; tone: StatusPillTone } | null {
  if (claimStatus === 'REJECTED') {
    return { label: 'Rejected', tone: 'danger' };
  }
  if (claimStatus === 'DENIED') {
    return { label: 'Denied', tone: 'danger' };
  }
  if (claimStatus === 'CANCELLED') {
    return { label: 'Voided', tone: 'neutral' };
  }
  if (claimStatus === 'PAID') {
    return { label: 'Paid', tone: 'success' };
  }
  if (claimStatus === 'PENDING_PAYMENT') {
    return { label: 'Pending Payment', tone: 'info' };
  }
  return null;
}
